// eslint-disable-next-line object-curly-newline
import { mdiHomeOutline, mdiPipe } from '@mdi/js'
import projects from './projects'
import coworkers from './coworkers'
import access from './access'
import financial from './financial'
import reports from './reports'
import satchel from './satchel'

export default [
  {
    title: 'Menu.Dashboard',
    icon: mdiHomeOutline,
    to: 'home',
    action: 'can_see_dashboard',
  },
  ...satchel,
  ...projects,
  ...coworkers,
  ...financial,
  ...reports,
  {
    title: 'Menu.Profiles',
    icon: mdiPipe,
    to: 'profiles',
    action: 'can_see_profile_menu',
  },
  ...access,
]
